import { GraphQLQuery } from '../graphqlClient';

const name = 'cruises_FilterOptions';

const graphqlQuery: GraphQLQuery = {
	name,
	query: `query ${name} {
    cruiseSearch {
      filters {
        __typename
        key
        facets {
          code
          count
        }
        ... on CruiseDateRangeFilter {
          startDate
          endDate
        }
        ... on CruiseGroupListFilter {
          groups {
            code
            label
            options {
              code
              label
              ... on CruiseBasicFilterOption {
                media {
                  images {
                    path
                  }
                }
              }
            }
          }
        }
        ... on CruiseListFilter {
          options {
            code
            label
            ... on CruiseBasicFilterOption {
              media {
                images {
                  path
                }
              }
            }
            ... on CruiseCustomFilterOption {
              containers
              criteria
              section
              urlParams {
                key
                value
              }
            }
            ... on CruiseSortFilterOption {
              attribute
              order
            }
          }
        }
        ... on CruiseNumberRangeFilter {
          min
          max
        }
      }
    }
  }`,
};

export default graphqlQuery;
